var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascotasWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mascotas_White",
    "data-name": "Mascotas White",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 229.407,
    height: 288.231,
    viewBox: "0 0 229.407 288.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbfaf1;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    className: "cls-1",
    width: 229.408,
    height: 288.231
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-1",
    d: "M227.814,98.712l-21.7-40.946a26.676,26.676,0,0,0-23.625-14.212H122.667V18.9a18.9,18.9,0,0,0-37.8,0V43.553H11.4A11.414,11.414,0,0,0,0,54.952v101.97a11.412,11.412,0,0,0,11.4,11.4H84.868v86.5H38.71a9.238,9.238,0,0,0-9.227,9.227v14.961a9.24,9.24,0,0,0,9.227,9.227H168.825a9.242,9.242,0,0,0,9.227-9.227V264.046a9.24,9.24,0,0,0-9.227-9.227H122.667v-86.5h59.648a26.626,26.626,0,0,0,23.776-14.51L227.9,111.4a13.722,13.722,0,0,0-.082-12.683M96.653,18.9a7.115,7.115,0,0,1,14.23,0V43.553H96.653ZM120.11,266.6h46.158v9.846h-125V266.6H87.425a9.24,9.24,0,0,0,9.227-9.227V168.321h14.23v89.054a9.238,9.238,0,0,0,9.227,9.227m97.3-160.594-21.8,42.413a14.9,14.9,0,0,1-13.3,8.114H11.785V55.338H182.493A14.913,14.913,0,0,1,195.7,63.287l21.7,40.943a1.919,1.919,0,0,1,.015,1.779",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-1",
    d: "M44.79,44.058A8.955,8.955,0,0,0,53.744,35.1V30.626a8.953,8.953,0,0,0-17.907,0V35.1a8.955,8.955,0,0,0,8.953,8.953",
    transform: "translate(69.745 42.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-1",
    d: "M35.672,44.058A8.953,8.953,0,0,0,44.626,35.1V30.626a8.953,8.953,0,0,0-17.907,0V35.1a8.955,8.955,0,0,0,8.953,8.953",
    transform: "translate(52 42.178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-1",
    d: "M50.868,29.271a8.953,8.953,0,0,0-8.953,8.953V42.7a8.953,8.953,0,1,0,17.907,0V38.224a8.955,8.955,0,0,0-8.953-8.953",
    transform: "translate(81.574 56.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-1",
    d: "M38.548,42.7V38.224a8.953,8.953,0,1,0-17.907,0V42.7a8.953,8.953,0,0,0,17.907,0",
    transform: "translate(40.171 56.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-1",
    d: "M64.43,37.987h0a13.3,13.3,0,0,0-21.165,0L27,59.368A13.3,13.3,0,0,0,37.578,80.716H70.116A13.294,13.294,0,0,0,80.7,59.371Z",
    transform: "translate(47.257 63.719)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotasWhite);
export default __webpack_public_path__ + "static/media/Mascotas White.1070593dce9c62ec4116de5d6debfb13.svg";
export { ForwardRef as ReactComponent };